<template>
  <div class="news-page">
    <!-- 1. 顶部Banner -->
    <section class="hidden md:block relative w-full overflow-hidden">
      <img src="@/assets/news/Group_26.png" alt="蘑菇产业红利新闻速览" class="w-full h-full object-cover">
      <div class="absolute inset-0 text-center top-[20%] text-white z-10">
        <h1 class="text-[clamp(2.5rem,5vw,4rem)] font-bold mb-3">蘑菇产业红利新闻速览</h1>
        <p class="text-[clamp(0.9rem,2vw,1rem)] max-w-lg text-center px-4 mx-auto">
          政策+市场双轮驱动，蘑菇产业迎黄金增长期</p>
      </div>
    </section>

    <section class="block md:hidden relative w-full overflow-hidden h-[80vh]">
      <!-- 背景图 -->
      <img src="@/assets/product/mb_bg5.png" class="absolute inset-0 w-[100%] h-[100%]" alt="" />
      <!-- 深色遮罩提升文字可读性 -->
      <div class="absolute inset-0 bg-black/15"></div>

      <div class="relative z-10 w-full pt-[20%] px-6 flex flex-col items-center text-white">
        <img src="@/assets/logo_H.png" alt="菌丰生物" class="mb-6">
        <!-- 主标题 -->
        <h2 class="text-[24px] font-bold mb-2 text-center">蘑菇产业红利新闻速览</h2>
        <!-- 描述文字 -->
        <p class="text-[10px] leading-6 text-center opacity-90 mb-10">
          政策 + 市场双轮驱动，蘑菇产业迎黄金增长期
        </p>
      </div>
    </section>
    <div class=" text-black px-8 mt-6 rounded-lg md:hidden block">
      <div class="flex justify-between items-center">
        <div>
          <div class="text-center">
            <svg t="1776758926412" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"
              p-id="2504" width="24" height="24">
              <path
                d="M660.8 959.6c-31.7 0-62.4-6.2-91.4-18.4-28-11.8-53.1-28.8-74.7-50.3-21.6-21.6-38.5-46.7-50.3-74.7-12.3-29-18.4-59.7-18.4-91.4 0-31.7 6.2-62.4 18.4-91.4 11.8-28 28.8-53.1 50.3-74.7 21.6-21.6 46.7-38.5 74.7-50.3 29-12.3 59.7-18.4 91.4-18.4 31.7 0 62.4 6.2 91.4 18.4 28 11.8 53.1 28.8 74.7 50.3 21.6 21.6 38.5 46.7 50.3 74.7 12.3 29 18.4 59.7 18.4 91.4 0 31.7-6.2 62.4-18.4 91.4-11.8 28-28.8 53.1-50.3 74.7-21.6 21.6-46.7 38.5-74.7 50.3-29 12.1-59.8 18.4-91.4 18.4z m0-437.5c-54.1 0-105 21.1-143.3 59.3-38.3 38.2-59.3 89.2-59.3 143.3 0 54.1 21.1 105 59.3 143.3 38.2 38.3 89.2 59.3 143.3 59.3 54.1 0 105-21.1 143.3-59.3 38.3-38.2 59.3-89.1 59.3-143.3 0-54.2-21.1-105-59.3-143.3-38.3-38.3-89.2-59.3-143.3-59.3z m0 0"
                p-id="2505" fill="#41B56F"></path>
              <path
                d="M739.9 757.3h-78.4c-8.9 0-16.1-7.2-16.1-16.1V596.3c0-8.9 7.2-16.1 16.1-16.1 8.9 0 16.1 7.2 16.1 16.1v128.8h62.3c8.9 0 16.1 7.2 16.1 16.1 0 9-7.2 16.1-16.1 16.1z m0 0"
                p-id="2506" fill="#41B56F"></path>
              <path
                d="M175.8 145.8h7.2c2.8 0 5.5 1.4 7.1 3.7l64.7 94.1h0.7v-89.3c0-4.7 3.8-8.6 8.6-8.6h3c4.7 0 8.6 3.8 8.6 8.6v114.5c0 4.7-3.8 8.6-8.6 8.6h-6.5c-2.8 0-5.5-1.4-7.1-3.7L188 178.4h-0.7v90.4c0 4.7-3.8 8.6-8.6 8.6h-3c-4.7 0-8.6-3.8-8.6-8.6V154.4c0.1-4.7 4-8.6 8.7-8.6zM310.2 145.8h77.4c4.7 0 8.6 3.8 8.6 8.6 0 4.7-3.8 8.6-8.6 8.6h-57.3c-4.7 0-8.6 3.8-8.6 8.6v21.2c0 4.7 3.8 8.6 8.6 8.6h52.9c4.7 0 8.6 3.8 8.6 8.6 0 4.7-3.8 8.6-8.6 8.6h-52.9c-4.7 0-8.6 3.8-8.6 8.6v24.7c0 4.7 3.8 8.6 8.6 8.6h60.5c4.7 0 8.6 3.8 8.6 8.6 0 4.7-3.8 8.6-8.6 8.6h-80.5c-4.7 0-8.6-3.8-8.6-8.6V154.4c-0.1-4.7 3.7-8.6 8.5-8.6zM423.7 145.8c3.9 0 7.4 2.7 8.3 6.5l24 96h0.7l25.2-96.1c1-3.8 4.4-6.4 8.3-6.4h7.8c3.9 0 7.3 2.6 8.3 6.4l25.2 96.1h0.7l24-96c1-3.8 4.4-6.5 8.3-6.5h4.6c5.7 0 9.8 5.5 8.2 10.9l-33 114.5c-1.1 3.7-4.4 6.2-8.2 6.2h-8.3c-3.9 0-7.3-2.6-8.3-6.4l-25-95.2h-0.7l-25 95.2c-1 3.8-4.4 6.4-8.3 6.4H452c-3.8 0-7.2-2.5-8.2-6.2l-32.9-114.5c-1.6-5.5 2.5-10.9 8.2-10.9h4.6zM568.3 398.9h-400c-0.6 0-1.1-0.5-1.1-1.1v-9.5c0-0.6 0.5-1.1 1.1-1.1h400c0.6 0 1.1 0.5 1.1 1.1v9.5c0 0.6-0.5 1.1-1.1 1.1zM343.2 513.8H168.3c-0.6 0-1.1-0.5-1.1-1.1v-9.5c0-0.6 0.5-1.1 1.1-1.1h174.8c0.6 0 1.1 0.5 1.1 1.1v9.5c0.1 0.6-0.4 1.1-1 1.1zM343.2 628.7H168.3c-0.6 0-1.1-0.5-1.1-1.1v-9.5c0-0.6 0.5-1.1 1.1-1.1h174.8c0.6 0 1.1 0.5 1.1 1.1v9.5c0.1 0.7-0.4 1.1-1 1.1zM343.2 743.7H168.3c-0.6 0-1.1-0.5-1.1-1.1v-9.5c0-0.6 0.5-1.1 1.1-1.1h174.8c0.6 0 1.1 0.5 1.1 1.1v9.5c0.1 0.6-0.4 1.1-1 1.1z"
                fill="#41B56F" p-id="2507"></path>
              <path
                d="M350.7 900.6c0-7-5.6-12.6-12.6-12.6H128.5c-18.2 0-33.1-13.7-33.1-30.6V122.7c0-16.9 14.8-30.6 33.1-30.6h488c18.2 0 33.1 13.7 33.1 30.6v297.9c0 7.5 6.1 13.6 13.6 13.6s13.6-6.1 13.6-13.6V122.7c0-30.8-27-55.9-60.3-55.9h-488c-33.2 0-60.3 25.1-60.3 55.9v734.6c0 30.8 27 55.9 60.3 55.9h209.6c6.9 0 12.6-5.7 12.6-12.6z"
                fill="#41B56F" p-id="2508"></path>
            </svg>
          </div>
          <h4 class="text-sm font-bold mb-2 text-center">蘑菇产业迎来政策与市场双重红利</h4>
          <p class="text-[10px] text-gray-500 text-center">中央一号文件加持、健康消费升温，食用菌成为农业新增长点，工厂化种植与品牌化发展提速，行业进入高增长红利期。</p>
        </div>
      </div>
    </div>
    <!-- 2. 新闻列表区 -->
    <section class="md:py-16  md:max-w-[56%] max-w-[94%] mx-auto md:px-4">
      <!-- 标题栏 -->
      <div class="bg-gray-100 p-6">
        <!-- 顶部标题栏 -->
        <div class="flex justify-between items-center mb-6">
          <h3 class="text-base font-bold text-[#000]">本期新闻热点</h3>
          <!-- <a href="javascript:;" class="text-[#41B56F] text-sm flex items-center gap-1">
            查看更多 <span>→</span>
          </a> -->
        </div>

        <!-- 新闻1 -->
          <div
          class="bg-white border-b border-gray-200 md:p-6 group transition-shadow duration-300 md:hover:shadow-lg mb-6">
          <div class="flex flex-col md:flex-row gap-6">
            <!-- 图片容器 -->
            <div class="w-full md:w-1/2 overflow-hidden">
              <img src="@/assets/news/image4.jpg" alt="成都发现新菌种"
                class="list-img w-full h-auto object-cover transition-all duration-500 group-hover:scale-110">
            </div>

            <div class="w-full md:w-1/2 flex flex-col justify-center">
              <!-- 标题变色 -->
              <h4
                class="md:text-2xl text-[14px] font-bold text-[#000] mb-3 transition-colors duration-300 group-hover:text-[#41B56F]">
                总投资2亿元，占地150亩，又一大型食用菌项目正式签约！
              </h4>
              <p class="md:text-[16px] text-[10px]  leading-[1.8] mb-4 text-gray-600  indent-8">
              近日，北京菌丰生物科技有限公司智能食用菌仿生仓立体种植农业项目正式签约，落户重庆江津江津区白沙镇。</p>
              <button @click="goDetail(1)"
                class="bg-[#41B56F] text-white text-xs px-4 py-1 self-start hover:opacity-90 transition">
                查看详情
              </button>
            </div>
          </div>
        </div>

        <div class="w-full h-[1px] bg-[#999999]"></div>
        <div
          class="bg-white border-b border-gray-200 md:p-6 group transition-shadow duration-300 md:hover:shadow-lg mb-6">
          <div class="flex flex-col md:flex-row gap-6">
            <!-- 图片容器 -->
            <div class="w-full md:w-1/2 overflow-hidden">
              <img src="@/assets/news/Rectangle_47.png" alt="成都发现新菌种"
                class="list-img w-full h-auto object-cover transition-all duration-500 group-hover:scale-110">
            </div>

            <div class="w-full md:w-1/2 flex flex-col justify-center">
              <!-- 标题变色 -->
              <h4
                class="md:text-2xl text-[14px] font-bold text-[#000] mb-3 transition-colors duration-300 group-hover:text-[#41B56F]">
                可食用！成都再次发现新的菌种
              </h4>
              <p class="md:text-[16px] text-[10px]  leading-[1.8] mb-4 text-gray-600 indent-8">
                今日，记者从金堂县获悉，西南科技大学生命科学与农林学院教授（退休）——贺新生在金堂县赵家镇意外发现了野生草菇菌种，它不仅打破了草菇生长的传统季节限制，更具有独特的低温适应性。
              </p>
              <button @click="goDetail(2)"
                class="bg-[#41B56F] text-white text-xs px-4 py-1 self-start hover:opacity-90 transition">
                查看详情
              </button>
            </div>
          </div>
        </div>

        <div class="w-full h-[1px] bg-[#999999]"></div>

        <!-- 新闻2 -->
        <div
          class="bg-white border-b border-gray-200 md:p-6 group transition-shadow duration-300 md:hover:shadow-lg mt-6">
          <div class="flex flex-col md:flex-row gap-6">
            <!-- 图片容器 -->
            <div class="w-full md:w-1/2 overflow-hidden">
              <img src="@/assets/news/image5.jpg" alt="成都发现新菌种"
                class="list-img w-full h-auto object-cover transition-all duration-500 group-hover:scale-110">
            </div>

            <div class="w-full md:w-1/2 flex flex-col justify-center">
              <!-- 标题变色 -->
              <h4
                class="md:text-2xl text-[14px] font-bold text-[#000] mb-3 transition-colors duration-300 group-hover:text-[#41B56F]">
                第十二批新增24个！食用菌累计39个属（种）纳入农业植物品种保护名录
              </h4>
              <p class="md:text-[16px] text-[10px] leading-[1.8] mb-4 text-gray-600 indent-8 indent-8">
                9月30日，农业农村部发布中华人民共和国农业农村部令2026年第1号，公布《中华人民共和国农业植物品种保护名录（第十二批）》。</p>
              <button @click="goDetail(3)"
                class="bg-[#41B56F] text-white text-xs px-4 py-1 self-start hover:opacity-90 transition">
                查看详情
              </button>
            </div>
          </div>
        </div>
        <!-- 底部绿色Banner -->
        <div class="bg-[#41B56F] text-white p-8 mt-6 rounded-lg hidden md:block">
          <div class="flex justify-between items-center">
            <div>
              <div class="flex">
                <svg t="1776758926412" class="icon" viewBox="0 0 1024 1024" version="1.1"
                  xmlns="http://www.w3.org/2000/svg" p-id="2504" width="24" height="24">
                  <path
                    d="M660.8 959.6c-31.7 0-62.4-6.2-91.4-18.4-28-11.8-53.1-28.8-74.7-50.3-21.6-21.6-38.5-46.7-50.3-74.7-12.3-29-18.4-59.7-18.4-91.4 0-31.7 6.2-62.4 18.4-91.4 11.8-28 28.8-53.1 50.3-74.7 21.6-21.6 46.7-38.5 74.7-50.3 29-12.3 59.7-18.4 91.4-18.4 31.7 0 62.4 6.2 91.4 18.4 28 11.8 53.1 28.8 74.7 50.3 21.6 21.6 38.5 46.7 50.3 74.7 12.3 29 18.4 59.7 18.4 91.4 0 31.7-6.2 62.4-18.4 91.4-11.8 28-28.8 53.1-50.3 74.7-21.6 21.6-46.7 38.5-74.7 50.3-29 12.1-59.8 18.4-91.4 18.4z m0-437.5c-54.1 0-105 21.1-143.3 59.3-38.3 38.2-59.3 89.2-59.3 143.3 0 54.1 21.1 105 59.3 143.3 38.2 38.3 89.2 59.3 143.3 59.3 54.1 0 105-21.1 143.3-59.3 38.3-38.2 59.3-89.1 59.3-143.3 0-54.2-21.1-105-59.3-143.3-38.3-38.3-89.2-59.3-143.3-59.3z m0 0"
                    p-id="2505" fill="#ffffff"></path>
                  <path
                    d="M739.9 757.3h-78.4c-8.9 0-16.1-7.2-16.1-16.1V596.3c0-8.9 7.2-16.1 16.1-16.1 8.9 0 16.1 7.2 16.1 16.1v128.8h62.3c8.9 0 16.1 7.2 16.1 16.1 0 9-7.2 16.1-16.1 16.1z m0 0"
                    p-id="2506" fill="#ffffff"></path>
                  <path
                    d="M175.8 145.8h7.2c2.8 0 5.5 1.4 7.1 3.7l64.7 94.1h0.7v-89.3c0-4.7 3.8-8.6 8.6-8.6h3c4.7 0 8.6 3.8 8.6 8.6v114.5c0 4.7-3.8 8.6-8.6 8.6h-6.5c-2.8 0-5.5-1.4-7.1-3.7L188 178.4h-0.7v90.4c0 4.7-3.8 8.6-8.6 8.6h-3c-4.7 0-8.6-3.8-8.6-8.6V154.4c0.1-4.7 4-8.6 8.7-8.6zM310.2 145.8h77.4c4.7 0 8.6 3.8 8.6 8.6 0 4.7-3.8 8.6-8.6 8.6h-57.3c-4.7 0-8.6 3.8-8.6 8.6v21.2c0 4.7 3.8 8.6 8.6 8.6h52.9c4.7 0 8.6 3.8 8.6 8.6 0 4.7-3.8 8.6-8.6 8.6h-52.9c-4.7 0-8.6 3.8-8.6 8.6v24.7c0 4.7 3.8 8.6 8.6 8.6h60.5c4.7 0 8.6 3.8 8.6 8.6 0 4.7-3.8 8.6-8.6 8.6h-80.5c-4.7 0-8.6-3.8-8.6-8.6V154.4c-0.1-4.7 3.7-8.6 8.5-8.6zM423.7 145.8c3.9 0 7.4 2.7 8.3 6.5l24 96h0.7l25.2-96.1c1-3.8 4.4-6.4 8.3-6.4h7.8c3.9 0 7.3 2.6 8.3 6.4l25.2 96.1h0.7l24-96c1-3.8 4.4-6.5 8.3-6.5h4.6c5.7 0 9.8 5.5 8.2 10.9l-33 114.5c-1.1 3.7-4.4 6.2-8.2 6.2h-8.3c-3.9 0-7.3-2.6-8.3-6.4l-25-95.2h-0.7l-25 95.2c-1 3.8-4.4 6.4-8.3 6.4H452c-3.8 0-7.2-2.5-8.2-6.2l-32.9-114.5c-1.6-5.5 2.5-10.9 8.2-10.9h4.6zM568.3 398.9h-400c-0.6 0-1.1-0.5-1.1-1.1v-9.5c0-0.6 0.5-1.1 1.1-1.1h400c0.6 0 1.1 0.5 1.1 1.1v9.5c0 0.6-0.5 1.1-1.1 1.1zM343.2 513.8H168.3c-0.6 0-1.1-0.5-1.1-1.1v-9.5c0-0.6 0.5-1.1 1.1-1.1h174.8c0.6 0 1.1 0.5 1.1 1.1v9.5c0.1 0.6-0.4 1.1-1 1.1zM343.2 628.7H168.3c-0.6 0-1.1-0.5-1.1-1.1v-9.5c0-0.6 0.5-1.1 1.1-1.1h174.8c0.6 0 1.1 0.5 1.1 1.1v9.5c0.1 0.7-0.4 1.1-1 1.1zM343.2 743.7H168.3c-0.6 0-1.1-0.5-1.1-1.1v-9.5c0-0.6 0.5-1.1 1.1-1.1h174.8c0.6 0 1.1 0.5 1.1 1.1v9.5c0.1 0.6-0.4 1.1-1 1.1z"
                    fill="#ffffff" p-id="2507"></path>
                  <path
                    d="M350.7 900.6c0-7-5.6-12.6-12.6-12.6H128.5c-18.2 0-33.1-13.7-33.1-30.6V122.7c0-16.9 14.8-30.6 33.1-30.6h488c18.2 0 33.1 13.7 33.1 30.6v297.9c0 7.5 6.1 13.6 13.6 13.6s13.6-6.1 13.6-13.6V122.7c0-30.8-27-55.9-60.3-55.9h-488c-33.2 0-60.3 25.1-60.3 55.9v734.6c0 30.8 27 55.9 60.3 55.9h209.6c6.9 0 12.6-5.7 12.6-12.6z"
                    fill="#ffffff" p-id="2508"></path>
                </svg>
                <p class="text-xs opacity-80 mb-1">菌丰新闻</p>
              </div>
              <h4 class="text-xl font-bold mb-2">蘑菇产业迎来政策与市场双重红利</h4>
              <p class="text-sm opacity-90">2025 年中央一号文件明确「食用菌产业提质增效」，大食物观国家战略，政策红利持续释放。</p>
            </div>
            <!-- <button class="bg-white text-[#41B56F] text-sm px-4 py-1 rounded-full">
              查看更多
            </button> -->
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "NewsPage",
  methods: {
    goDetail(id) {
      this.$router.push(`/news/detail?id=${id}`);
    }
  }
}
</script>

<style scoped>
/* 基础过渡效果 */
img {
  transition: transform 0.3s ease;
}

.list-img:hover {
  transform: scale(1.02);
}

button {
  border: none;
  cursor: pointer;
}
</style>